import {connect} from "react-redux";
import {mapStateToProps} from "../../store/helpers/mapState";
import {mapDispatchToProps} from "../../store/helpers/mapDispatch";
import React, {useEffect} from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import BasicMenu from "../../helpers/menu";
import FormDialog from "../../helpers/FormDialog";
import DeleteDialog from "../../helpers/DeleteDialog";
import {Button, DialogContent, DialogContentText, Switch} from "@mui/material";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import {useHistory} from "react-router";
function Position({SetSelectedMenu}) {

    const [open,setOpen] = React.useState(0);
    const [value,setValue] = React.useState({});
    const [list,setList] = React.useState([]);
    const [id,setId] = React.useState();
    const [count,setCount] = React.useState(0);
    const [deleteOpen,setDeleteOpen] = React.useState(false);
    const [openStatus,setOpenStatus] = React.useState(false);
    const [openIntStatus,setOpenIntStatus] = React.useState(false);
    const [requirements, setRequirements] = React.useState(null);

    const history = useHistory();


    const columns = [
        {
            name: "name",
            label: "Title",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "id",
            data:"status",
            label: "Active",
            options: {
                filter: true,
                sort: true,
                customBodyRender:(v)=>{

                    const obj = list.find(it=>it.id === v);
                    return <Switch checked={obj?.status === true} onChange={()=>{
                        setId(v);
                        setOpenStatus(true);
                    }}/>;
                }
            },
        },
        {
            name: "id",
            data:"international",
            label: "International",
            options: {
                filter: true,
                sort: true,
                customBodyRender:(v)=>{

                    const obj = list.find(it=>it.id === v);
                    return <Switch checked={obj?.international === true} onChange={()=>{
                        setId(v);
                        setOpenIntStatus(true);
                    }}/>;
                }
            },
        },
        {
            name:"deadline",
            label:"Deadline",
            options: {
                customBodyRender:(v)=> v ? moment(v).format("YYYY-MMM-DD") : ""
            }
        },
        {
            name:"requirements",
            label:"Requirements",
            options: {
                customBodyRender:(v)=> v ? <Button onClick={()=>setRequirements(v)}>Show</Button> : ""
            }
        },
        {
            name:"createdAt",
            label:"Created At",
            options: {
                customBodyRender:(v)=> v ? moment(v).format("YYYY-MMM-DD HH:mm") : ""
            }
        },
        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender:(v)=><BasicMenu  extra={[
                    {
                        label:"Exam Question",
                        onClick:()=>{
                            history.push(`/admin/exams/${v}`)
                        }
                    }
                ]} onDelete={()=>{
                    setDeleteOpen(true);
                    setId(v);
                }} onEdit={()=>{
                    setOpen(2);
                    const obj = list.find(vx=>vx.id === v);
                    setId(v);
                    setValue({...obj,deadline:moment(obj.deadline).format("YYYY-MM-DD")});
                }}/>
            },
        },
    ];

    const onSuccess = ()=>setCount(v=>v+1);


    return <div className="w-full">
        <Dialog open={requirements !== null} onClose={()=>setRequirements(null)}>
            <DialogContent>
                <DialogContentText>
                    <div dangerouslySetInnerHTML={{__html:requirements}}></div>
                </DialogContentText>
            </DialogContent>
        </Dialog>
        <DeleteDialog open={openStatus} info={true} setOpen={()=>setOpenStatus(false)} title={'Change Status'} bodyText={'Change status of this position ?'} onSuccess={onSuccess} url={`/api/position/change/status/${id}`}/>
        <DeleteDialog open={openIntStatus} info={true} setOpen={()=>setOpenIntStatus(false)} title={'Change International Status'} bodyText={'Change International status of this position ?'} onSuccess={onSuccess} url={`/api/position/change/international/${id}`}/>
        <DeleteDialog open={deleteOpen} setOpen={()=>setDeleteOpen(false)} onSuccess={onSuccess} url={`/api/position/delete/${id}`}/>
        <FormDialog open={open>0} onSuccess={onSuccess} setOpen={setOpen} url={open === 1 ? '/api/position/create' : `/api/position/update/${id}`} title={open ===1 ? "Create New Position" : "Edit Position"} fields={[
            {
                name:"name",
                label:"Position name",
                value:value['name'],
                required:true,
                setValue:(val)=>setValue(v=>({...v,name:val})),
            },
            {
                name:"deadline",
                label:"Deadline",
                value:value['deadline'],
                type:'date',
                required:true,
                minDate:moment(),
                setValue:(val)=>setValue(v=>({...v,deadline:val})),
            },
            {
                name:"requirements",
                label:"Job Requirements",
                value:value['requirements'],
                type:'editor',
                setValue:(val)=>setValue(v=>({...v,requirements:val})),
            },
        ]}/>
        <DatatableComponent onAddNew={()=>setOpen(1)} processData={(data)=>{
            setList(data.data);
            return data;
        }} elevation={1} columns={columns} url={`/api/position/list?count=${count}`} title={"Recruit Positions"}/>
    </div>;
}

export default connect(mapStateToProps,mapDispatchToProps)(Position);
